export enum ListingSnapshotStatusEnum {
    MISSING = 0,
    REGENERATING = 1,
    AVAILABLE = 2,
    FAILED = 3,
    ROLLEDBACK = 4,
}

export interface ChannelSnapshot {
    id: string;
    isDeleted: boolean;
    trackingId: string;
    listingId: string;
    channelId: string;
    channelMappedValue: string;
    version: number;
    createdAt?: string;
    updatedAt?: string;
    status?: ListingSnapshotStatusEnum;
    rolledBack?: boolean;
}

export enum SnapshotGenerationType {
    UNKNOWN = 0,
    BOOKING_RPA = 1,
    EXPEDIA_RPA = 2,
    OLDER,
}

export enum SnapshotGenerationStalenessEnum {
    FRESH = 'fresh',
    STALE = 'stale',
    MISSING = 'missing',
}

export enum ChannelSnapshotChangeTypeEnum {
    MODIFIED = 'modified',
    DELETED = 'deleted',
    ADDED = 'added',
}

export type SnapshotPathEntries = Record<string, unknown>[];

export interface ActiveSnapshotPaths {
    [ChannelSnapshotChangeTypeEnum.MODIFIED]?: SnapshotPathEntries;
    [ChannelSnapshotChangeTypeEnum.ADDED]?: SnapshotPathEntries;
    [ChannelSnapshotChangeTypeEnum.DELETED]?: SnapshotPathEntries;
}

export interface SnapshotDifferenceResponse {
    id: string;
    label: string;
    differences: {
        onChNotOnChannel: Record<string, unknown>;
        onChannelNotOnCh: Record<string, unknown>;
        modified: Record<string, unknown>;
    };
}

export interface SnapshotDifferenceLocal {
    id: string;
    label: string;
    differences: ActiveSnapshotPaths;
}
